import { getDefaultLang } from "@cervval.js/common/src/i18n/languages";

const _fr = {
    product: {
        config: {
            name: "Nom",
            defaultDescription: "Description",
            defaultPrice: "Prix (€)",
            type: "Catégorie"
        },
        type: {
            product: "Produit",
            service: "Service"
        }
    },
    periodicity: {
        weekly: "Hebdomadaire",
        monthly: "Mensuelle (4 semaines)",
        annually: "Annuelle (52 semaines)"
    }
};

export type _I18nPayment = typeof _fr;

const _en: _I18nPayment = {
    product: {
        config: {
            name: "Name",
            defaultDescription: "Description",
            defaultPrice: "Price (€)",
            type: "Category"
        },
        type: {
            product: "Product",
            service: "Service"
        }
    },
    periodicity: {
        weekly: "Weekly",
        monthly: "Monthly (4 weeks)",
        annually: "Annually (52 weeks)"
    }
};

/**
 * Return value in required language
 * @param lang Chosen lang
 * @returns 
 */
export function I18nPayment(lang?: string): _I18nPayment {
    lang = lang ?? getDefaultLang();
    switch (lang) {
        case "en":
            return _en;
        case "fr":
        default:
            return _fr;
    }
}